module.exports = __webpack_public_path__ + "img/first-0.58d5bb25.webp";